var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar navbar-expand-md navbar-dark fixed-top head-box"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/","title":"招鲤视频"}},[_c('h1',[_c('img',{staticClass:"logo",attrs:{"src":"https://p.cdn.izhaoli.cn/official_website/website/logo@2x.png","alt":"logo","title":"logo"}})])])])
}]

export { render, staticRenderFns }